var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plain-text",class:{ 'is-constrained': _vm.needsOverflowCheck, 'has-scroll': _vm.hasScroll },style:(_vm.computedStyle)},[_c('p',{ref:"content",domProps:{"innerHTML":_vm._s(_vm.fieldsData.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }